import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EntityRef, EntityType } from '../../core/settings/settings.service';
import { Entity } from '../../shared/entity-search/entity-search.service';
import { CohortEntity } from '../services/cohort.service';

@Component({
  selector: 'dcc-cohort-entities-details',
  templateUrl: './cohort-entities-details.component.html',
  styleUrls: ['./cohort-entities-details.component.scss'],
})
export class CohortEntitiesDetailsComponent {
  @Input() header: string;
  @Input() subHeader?: string;
  @Input() headerColor?: string;
  @Input() padding?: string;
  @Input() entities: Entity[];
  @Input() legacyEntities: CohortEntity[];
  @Input() enableRemove = false;
  @Input() setting?: string;
  @Output() remove = new EventEmitter<Entity>();
  @Output() removeLegacyEntity = new EventEmitter<CohortEntity>();

  getEntityPathWithoutEntityName(entity: Entity): string {
    if (
      entity.entityType === EntityType.company ||
      entity.entityType === EntityType.stack ||
      entity.entityType === EntityType.stack_deprecated
    ) {
      return entity.name;
    }

    const company = entity.path.find(
      (p) => p.entityType === EntityType.company,
    );

    return `${company?.name ? company.name : ''} ${this.addParentGroup(entity.path)} >`;
  }

  removeEntity(entity: Entity) {
    this.remove.emit(entity);
  }

  removeLegacyCohortEntity(legacyEntity: CohortEntity) {
    this.removeLegacyEntity.emit(legacyEntity);
  }

  private addParentGroup(path: EntityRef[]): string {
    const pathCopy = path.slice(0, path.length - 1).reverse();
    const parentGroup = pathCopy.find((p) => p.entityType === EntityType.group);

    const connector = pathCopy.length > 2 ? ' > ... > ' : ' > ';
    return parentGroup ? connector + parentGroup.name : '';
  }
}
